import React, { memo } from 'react';
import { ListItemBase } from './ListItem.base';
import { TouchableOpacity } from 'react-native';
/**
 * Primary UI component for user interaction
 */
const ListItem = ({ id, onPress, action, triggerAction, shouldShowHighlight, shouldCardClickable = true, ...props }) => {
    /**
     *  logic -> base-component(...props)
     * */
    const handleAction = () => {
        onPress && onPress();
        action &&
            triggerAction &&
            triggerAction(action);
    };
    return (React.createElement(TouchableOpacity, { activeOpacity: !shouldShowHighlight ? 1 : null, onPress: shouldCardClickable ? handleAction : null },
        React.createElement(ListItemBase, { onPress: onPress, ...props, id: id, rightIconClickableAction: !shouldCardClickable ? handleAction : undefined })));
};
export default memo(ListItem);
export { ListItem };
